import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=56b7d1db&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=56b7d1db&prod&lang=scss&"
import style1 from "./Layout.vue?vue&type=style&index=1&id=56b7d1db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7d1db",
  null
  
)

export default component.exports